import React from 'react';
import Head from 'next/head'
import { SeoItemInterface } from '../helper/PageInformationInterface';

export interface SeoProps {
  items: SeoItemInterface[]
}

export default function Og(props: SeoProps) {
    return (
      <Head>
        { (props && props.items) && props.items.map(item => {
          return <React.Fragment key={`key-og-${item.property}`}>
            { item.property === 'url' ?
              <meta key={`og-${item.property}`} property={`og:${item.property}`} content={`${process.env.NEXT_PUBLIC_BACKEND_URL}${item.content}`} />
              :
              <meta key={`og-${item.property}`} property={`og:${item.property}`} content={item.content} />
            }
            </React.Fragment>
        })}
      </Head>
    );
}